module.exports = __webpack_public_path__ + "img/core-connect.37038927.jpg";